<template>
  <article class="join-article">
    <div class="workspace-join" :style="style">
      <div v-if="workspace">
        <p>
          Vous avez été invité à rejoindre cet espace :
          <span class="workspace-name">{{ workspace.name }}</span>
        </p>
        <button
          v-if="isLoggedIn"
          class="button"
          @click="join"
          :disabled="loading"
        >
          Rejoindre
        </button>
        <button class="button" v-else @click="logAndComeBack">
          Se connecter & rejoindre
        </button>
      </div>
      <div v-else>
        <p>Une erreur est survenue.</p>
      </div>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
  </article>
</template>

<script>
import workspaceService from '../../services/workspace.service';
import cloudFunctionsService from '../../services/cloud-functions.service';

export default {
  components: {},
  props: {
    workspaceJoinId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      workspace: null,
      loading: false,
      error: null,
    };
  },
  created() {
    this.getWorkspaceData();
  },
  methods: {
    async getWorkspaceData() {
      if (!this.workspaceJoinId) {
        return;
      }
      this.workspace = await workspaceService.getWorkspace(
        this.workspaceJoinId
      );
    },

    /**
     * Permet de rejoindre un espace
     * Appel d'un cloud function
     * Vérifie le résultat et redirige
     */
    async join() {
      this.loading = true;
      cloudFunctionsService
        .joinWorkspace(this.currentUserId, this.workspaceJoinId)
        .then((data) => {
          if (data.success) {
            this.error = null;
            // Select this workspace
            if (this.workspaceJoinId !== this.currentWorkspace.id) {
              this.$store.dispatch('setCurrentWorkspace', this.workspaceJoinId);
            }
            // Redirect to home
            this.$router.push('/');
          } else {
            this.error = data.message;
          }
        });
    },

    /**
     * Pour user non connecté
     * Redirige vers la page Login et enregistre dans vuex l'espace à rejoindre
     */
    async logAndComeBack() {
      // Save this for later
      this.$store.dispatch('setWorkspaceIdToJoin', this.workspaceJoinId);
      /**
       * A utiliser quand :
       *  Un compte est créé
       *  Un compte se connecte
       */
      // Redirect to Login
      this.$router.push('/login');
    },
  },
  computed: {
    style() {
      return {
        borderLeft: this.workspace ? `5px solid ${this.workspace.color}` : '',
      };
    },
  },
};
</script>

<style lang="scss" scoped src="./Join.scss"></style>
